/* eslint-disable import/prefer-default-export */
import { Login } from './models';

export const DEFAULT_LOGIN: Login = {
  email: '',
  password: '',
};
